export default __webpack_public_path__ + "static/media/events-empty-icon.7a367e3a.svg";